/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import Container from '../../common/Container/Container'
import HeaderContainer from '../../common/HeaderContainer/HeaderContainer'
import RenewalsTable from './components/RenewalsTable'
import RenewalsTableHeader from './components/RenewalsTableHeader'
import Widget from '../../common/Widget/Widget'
import PopUp from '../../common/PopUp/PopUp'

import {
    inviteQuoteVariation,
    fecthLapseRenewal,
} from '../../../actions'

/**
 *     Import
 *     - CSS
 */
import './styles/Renewals.css'

/**
 * Renewlas section class
 *
 * @export
 * @class Renewals
 * @extends {React.Component<any, any>}
 */
export default class Renewals extends React.Component<any, any> {

    /**
     * Creates an instance of Renewals.
     * @param {*} props
     * @memberof Renewals
     */
    constructor(props: any) {
        super(props)
        this.state = {
            renewPolicyPopUp: {
                show: false,
                renewId: '',
            },
            futureExpiringPopUp: {
                show: false,
                renewId: '',
            },
            futureLapsePopUp: {
                show: false,
                renewId: '',
            },
            filters: {
                page: 1,
                perPage: 20,
                sortedBy: 'clientName',
                sortedType: 'asc',
            },
        }
    }

    componentWillMount() {
        let { page, perPage, sortedBy, sortedType } = this.state.filters
        this.props.fecthRenewalsList(page, perPage, sortedBy, sortedType)
    }

    /**
     * Check if there's state change,
     * if yes, Trigger the fetch to return new results
     * seding the new state as param
     */
    componentDidUpdate(prevProps: any, prevState: any) {

        let { page, perPage, sortedBy, sortedType } = this.state.filters

        if (prevState.filters !== this.state.filters) {
            this.props.fecthRenewalsList(page, perPage, sortedBy, sortedType)
        }
        // Invite Renewal as expiring
        if (prevState.futureExpiringPopUp.show === true && this.state.futureExpiringPopUp.show === false) {
            this.props.fecthRenewalsList(page, perPage, sortedBy, sortedType)
        }
        // lapse renewal
        if (prevState.futureLapsePopUp.show === true && this.state.futureLapsePopUp.show === false) {
            this.props.fecthRenewalsList(page, perPage, sortedBy, sortedType)
        }

    }

    /**
     * Trigger fot the header filters
     *
     * @memberof Renewals
     * @param {Object} params
     */
    filterTrigger = (params: any) => this.setState(
        {
            filters: {
                page: this.state.filters.page,
                perPage: this.state.filters.perPage,
                sortedBy: params.sortedBy,
                sortedType: params.sortedType,
            },
        }
    )

    showRenewPolicyPopUp = (state: any, newId: any) => {
        this.setState({
            renewPolicyPopUp: {
                show: state,
                renewId: newId,
            },
        })
    }

    showFutureExpiringPopUp = (state: any, newId: any) => {
        this.setState({
            futureExpiringPopUp: {
                show: state,
                renewId: newId,
            },
        })
    }

    showFutureLapsePopUp = (state: any, newId: any) => {
        this.setState({
            futureLapsePopUp: {
                show: state,
                renewId: newId,
            },
        })
    }

    render() {
        // Sets the length of the array
        // future, inReferral, invited, totalFuture, totalInReferral, totalInvited
        const { done, response } = this.props.renewals

        return (
            <div className="renewals">
                {(this.state.renewPolicyPopUp.show) ?
                    <div className="">
                        <PopUp
                            title={'Renew Policy'}
                            action={() => this.props.history
                                .push(`/renewals/bind/${this.state.renewPolicyPopUp.renewId}`)}
                            buttonText={'Bind Renewal'}
                            numberButtons={3}
                            secondaryAction={() => {
                                this.props.history
                                    .push(`/renewals/edit/${this.state.renewPolicyPopUp.renewId}`)

                            }}
                            secondaryButtonText={'Edit Renewal'}
                            thirdAction={() => { this.setState({ renewPolicyPopUp: { show: false } }) }}
                            thirdButtonText={'Back'}
                        >
                            In order to renew this policy please select whether you would like to renew on
                            existing details or edit the details. You can also download a PDF copy to send
                            to your client.
                            {/* <div className="download_pdf_policy">
                                Download pdf policy form
                            </div> */}
                        </PopUp>
                    </div>
                    : null}
                {(this.state.futureExpiringPopUp.show) ?
                    <div className="">
                        <PopUp
                            title={'Renew Policy'}
                            numberButtons={4}
                            action={() => this.props.history
                                .push(`/renewals/bind/${this.state.futureExpiringPopUp.renewId}`)}
                            buttonText={'Bind Renewal\n as expiring'}
                            secondaryAction={() => {
                                inviteQuoteVariation(this.state.futureExpiringPopUp.renewId)
                                this.setState({ futureExpiringPopUp: { show: false } })
                            }}
                            secondaryButtonText={'Invite Renewal\n as expiring'}
                            thirdAction={() => {
                                this.props.history
                                    .push(`/renewals/edit/${this.state.futureExpiringPopUp.renewId}`)
                            }}
                            thirdButtonText={'Edit Renewal'}
                            fourthAction={() => { this.setState({ futureExpiringPopUp: { show: false } }) }}
                            fourthButtonText={'Back'}
                        >
                            In order to renew this policy please select whether you would like to renew on
                            existing details or edit the details. You can also download a PDF copy to send
                            to your client.
                            <div className="download_pdf_policy">
                                Download expiring policy
                            </div>
                        </PopUp>
                    </div>
                    : null}
                {(this.state.futureLapsePopUp.show) ?
                    <div className="">
                        <PopUp
                            title={'Are you sure?'}
                            action={() => {
                                fecthLapseRenewal(this.state.futureLapsePopUp.renewId)
                                this.setState({ futureLapsePopUp: { show: false } })
                            }}
                            buttonText={'Continue'}
                            numberButtons={2}
                            secondaryAction={() => { this.setState({ futureLapsePopUp: { show: false } }) }}
                            secondaryButtonText={'Cancel'}
                        >
                            Do you really want to lapse the renewal?
                        </PopUp>
                    </div>
                    : null}
                <HeaderContainer
                    className="renewals__header"
                    fullwidth={true}
                    titles={['Renewals']}
                >
                    {done && <div className="renewalsCount">
                        {`${response.totalFuture} ${(response.totalFuture !== 1) ?
                            'policies' :
                            'policy'} up for renewal in the next 30 days`}
                    </div>}
                </HeaderContainer>

                <RenewalsTableHeader
                    state={this.state}
                    dataType={this.state.typeSelected}
                    filterTrigger={this.filterTrigger}
                />
                {done &&
                    (
                        <div className="renewals-widget__body">
                            <Widget
                                shadow={true}
                                className={
                                    `renewals-widget-quotes
                                                ${(response.inReferral.length === 0) ?
                                        'renewals-widget-quotes__void' : ''}
                                                `}
                            >
                                <div className="renewals-widget-quotes__title">
                                    <h3>In referral</h3>
                                    <p>
                                        {`${
                                            response.inReferral.length
                                            } ${response.inReferral.length !== 1 ?
                                                'renewals' :
                                                'renewal'
                                            } in referral`
                                        }
                                    </p>
                                </div>
                                <div className="your-quotes__content">
                                    <Container
                                        className="clients clients__table table__content"
                                        fullwidth={false}
                                    >
                                        <RenewalsTable
                                            renewalsList={
                                                (response.inReferral) ?
                                                    response.inReferral :
                                                    {}
                                            }
                                            dataType="inReferral"
                                            referralType="inReferral"
                                        />
                                    </Container>
                                </div>
                            </Widget>
                            <div
                                className={
                                    `no-results-widget
                                            ${(response.inReferral.length === 0) ?
                                        'active' :
                                        'blocked'}`
                                }
                            >
                                There are no renewals in referral
                            </div>
                            <Widget
                                shadow={true}
                                className={
                                    `renewals-widget-quotes
                                                ${(response.invited.length === 0) ?
                                        'renewals-widget-quotes__void' : ''}
                                                `}
                            >
                                <div className="renewals-widget-quotes__title">
                                    <h3>Invited renewals</h3>
                                    <p>
                                        {`${
                                            response.invited.length
                                            } pending invited
                                        ${response.invited.length !== 1 ?
                                                'renewals' :
                                                'renewal'
                                            }`
                                        }
                                    </p>
                                </div>
                                <div className="your-quotes__content">
                                    <Container
                                        className="clients clients__table table__content"
                                        fullwidth={false}
                                    >
                                        <RenewalsTable
                                            renewalsList={
                                                (response.invited) ?
                                                    response.invited :
                                                    {}
                                            }
                                            dataType="invitedRenewals"
                                            referralType="invitedRenewals"
                                            renewAsIs={this.props.renewAsIs.response}
                                            fecthRenewAsIs={(policyId) => this.props.fecthRenewAsIs(policyId)}
                                            fecthRenewPolicy={(policyId) => this.props.fecthRenewPolicy(policyId)}
                                            showRenewPolicyPopUp={this.showRenewPolicyPopUp}
                                            history={this.props.history}
                                        />
                                    </Container>
                                </div>
                            </Widget>
                            <div
                                className={`no-results-widget
                                            ${(response.invited.length === 0) ?
                                        'active' :
                                        'blocked'
                                    }`}
                            >
                                There are no results for invited renewals
                            </div>
                            <Widget
                                shadow={true}
                                className={
                                    `renewals-widget-policies
                                                ${(response.future.length === 0) ?
                                        'renewals-widget-policies__void' : ''}`}
                            >
                                <div className="renewals-widget-policies__title">
                                    <h3>Future renewals</h3>
                                    <p>
                                        {`${
                                            response.future.length
                                            } ${response.future.length !== 1 ?
                                                'policies' :
                                                'policy'
                                            } up for renewal in the next 30 days`
                                        }
                                    </p>
                                </div>
                                <div className="your-policies__content">
                                    <Container
                                        className="clients clients__table table__content"
                                        fullwidth={false}
                                    >
                                        <RenewalsTable
                                            renewalsList={
                                                (response.future) ?
                                                    response.future :
                                                    []
                                            }
                                            dataType="futureRenewals"
                                            // showRenewPolicyPopUp={this.showRenewPolicyPopUp}
                                            showRenewPolicyPopUp={this.showFutureExpiringPopUp}
                                            showLapseRenewPopUp={this.showFutureLapsePopUp}
                                        />
                                    </Container>
                                </div>
                            </Widget>
                            <div
                                className={`no-results-widget
                                            ${(response.future.length === 0) ?
                                        'active' :
                                        'blocked'}
                                                `}
                            >
                                There are no results for future renewals
                            </div>
                        </div>
                    )
                }

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Renewals/Renewals.tsx